export enum CallStatus {
  Expired = 'EXPIRED',
  Live = 'LIVE',
  Pending = 'PENDING',
  Canceled = 'CANCELED',
}
